import { render, staticRenderFns } from "./ConfiguracaoWebcheckout.vue?vue&type=template&id=36932072&"
import script from "./ConfiguracaoWebcheckout.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoWebcheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports